import ClaimDashboardIframe from "@/Pages/Claims/ClaimsDashboardIframe";
import NewEndorsementIframe from "@/Pages/Endorsements/NewEndorsementIFrame";
import GeoScopes from "@/Pages/GeoScopes";
import {
  Accounts,
  ActivityLog,
  AddPermissions,
  AlertLogs,
  Alerts,
  AlertTemplate,
  AllSegments,
  ApiToken,
  BankBranches,
  BlockedAreas,
  Branches,
  Breeds,
  BrocoreClaims,
  BrokerLandingPage,
  BusinessNatures,
  BusinessTypes,
  CancellationReasons,
  Cards,
  CardType,
  CashDeposit,
  CattleBreeds,
  CattleTypes,
  CertificateTemplates,
  Cities,
  ClaimExpenses,
  Claims,
  ClaimSettlementType,
  ClaimStages,
  ClaimsTypes,
  Combos,
  Commissions,
  CommissionSetting,
  CommodityType,
  Countries,
  Coupons,
  Credentials,
  CurrencyType,
  Dashboard,
  DefaultAlertTemplate,
  Endorsements,
  Entity,
  EventTypes,
  FeatureCategories,
  FeatureMaster,
  Gadgets,
  Gender,
  GeneralSettings,
  Home,
  IncoTerms,
  Insurers,
  JourneyLinksPage,
  KnockoutQuestions,
  Leads,
  Loading,
  MedicalQuestions,
  OccupancyType,
  Occupations,
  PackagingTypes,
  PartnerCertificate,
  PartnerLandingPage,
  PartnerPermissions,
  PartnerRoles,
  Partners,
  PartnerUsers,
  PaymentGateways,
  PaymentMode,
  PermissionsPage,
  Pincodes,
  PlacementSlipIframe,
  Plans,
  Policies,
  PolicyFeatures,
  PolicyListingIframe,
  ProductFeatures,
  Products,
  Profile,
  PropertyCoverages,
  ProposalBulkUpload,
  QCRIframe,
  RaterConfig,
  Relations,
  Renewals,
  Reports,
  RFQIframe,
  Riders,
  Roles,
  SalesTemplateIFrame,
  Segments,
  Specialization,
  Species,
  States,
  SubSegments,
  Template,
  Theme,
  Transactions,
  Users,
  WorkerType,
  Manufacturer,
  FuelType,
  Variant,
  Model,
  Consent,
} from "./AdminRouteImports";
import {
  InputsPageRender,
  JourneyComparePage,
  JourneyLandingPage,
  JourneyLeadDetails,
  JourneyPaymentGatewayPage,
  JourneyProposalPage,
  JourneyProposalSummaryPage,
  JourneyQuotesPage,
  JourneyThankyouPage,
} from "./JourneyRoutesImports";

type TSuspenseRouteHandlerProps = {
  route: string;
};
const AllPages = ({ route }: TSuspenseRouteHandlerProps) => {
  switch (route.toLowerCase()) {
    case "consent":
      return <Consent />;
    case "manufacturer":
      return <Manufacturer />;
    case "fuel type":
      return <FuelType />;
    case "model":
      return <Model />;
    case "variant":
      return <Variant />;
    case "sub segment":
      return <SubSegments />;
    case "geo scopes":
      return <GeoScopes />;
    case "commodity types":
      return <CommodityType />;
    case "specialization":
      return <Specialization />;
    case "commissions":
      return <Commissions />;
    case "business types":
      return <BusinessTypes />;
    case "dashboard":
      return <Dashboard />;
    case "cattle breeds":
      return <CattleBreeds />;
    case "commission setting":
      return <CommissionSetting />;
    case "worker types":
      return <WorkerType />;
    case "currency type":
      return <CurrencyType />;
    case "cattle types":
      return <CattleTypes />;
    case "partner permissions":
      return <PartnerPermissions />;
    case "block areas":
      return <BlockedAreas />;
    case "coupons":
      return <Coupons />;
    case "property coverages":
      return <PropertyCoverages />;
    case "cancellation reasons":
      return <CancellationReasons />;
    case "branches":
      return <Branches />;
    case "species":
      return <Species />;
    case "partner":
      return <Partners />;
    case "roles":
      return <Roles />;
    case "users":
      return <Users />;
    case "permissions":
      return <PermissionsPage />;
    case "insurers":
      return <Insurers />;
    case "relations":
      return <Relations />;
    case "genders":
      return <Gender />;
    case "credentials":
      return <Credentials />;
    case "occupations":
      return <Occupations />;
    case "feature master":
      return <FeatureMaster />;
    case "feature categories":
      return <FeatureCategories />;
    case "payment mode":
      return <PaymentMode />;
    case "payment gateways":
      return <PaymentGateways />;
    case "products":
      return <Products />;
    case "product features":
      return <ProductFeatures />;
    case "cities":
      return <Cities />;
    case "states":
      return <States />;
    case "countries":
      return <Countries />;
    case "communication":
      return <Alerts />;
    case "pincodes":
      return <Pincodes />;
    case "bank branches":
      return <BankBranches />;
    case "themes":
      return <Theme />;
    case "general settings":
      return <GeneralSettings />;
    case "plans":
      return <Plans />;
    case "combos":
      return <Combos />;
    case "policies":
      return <Policies />;
    case "policy features":
      return <PolicyFeatures />;
    case "leads":
      return <Leads />;
    case "certificate templates":
      return <CertificateTemplates />;
    case "alert templates":
      return <AlertTemplate />;
    case "cash deposits":
      return <CashDeposit />;
    case "accounts":
      return <Accounts />;
    case "profile":
      return <Profile />;
    case "default alert template":
      return <DefaultAlertTemplate />;
    case "journey links":
      return <JourneyLinksPage />;
    case "segments":
      return <Segments />;
    case "proposal bulk upload":
      return <ProposalBulkUpload />;
    case "certificates":
      return <PartnerCertificate />;
    //TEMPLATE
    case "claim template":
      return <Template />;
    // CLAIMS
    case "claims submission":
      return <Claims />;
    case "claim settlement type":
      return <ClaimSettlementType />;
    case "claims dashboard":
      return <ClaimDashboardIframe />;
    // return <ClaimsDashbord />;
    case "claim types":
      return <ClaimsTypes />;
    case "claim expenses":
      return <ClaimExpenses />;
    case "claim stages":
      return <ClaimStages />;
    case "partner users":
      return <PartnerUsers />;
    case "partner roles":
      return <PartnerRoles />;
    case "transactions":
      return <Transactions />;
    case "add permissions":
      return <AddPermissions />;
    case "loading":
      return <Loading />;
    case "card types":
      return <CardType />;
    case "cards":
      return <Cards />;
    case "reports":
      return <Reports />;
    case "api tokens":
      return <ApiToken />;
    case "incoterms":
      return <IncoTerms />;
    case "business nature":
      return <BusinessNatures />;
    case "event types":
      return <EventTypes />;
    case "packaging types":
      return <PackagingTypes />;
    case "rater config":
      return <RaterConfig />;
    case "policy listing":
      return <PolicyListingIframe />;
    case "riders":
      return <Riders />;
    case "gadgets":
      return <Gadgets />;
    case "alert logs":
      return <AlertLogs />;

    // IFRAMES
    case "rfq":
      return <RFQIframe />;
    case "qcr":
      return <QCRIframe />;
    case "claims":
      return <BrocoreClaims />;
    case "endorsements":
      return <Endorsements />;
    case "placement slip":
      return <PlacementSlipIframe />;
    case "sales template":
      return <SalesTemplateIFrame />;
    case "renewals":
      return <Renewals />;
    case "partner landing page":
      return <PartnerLandingPage />;
    case "broker landing page":
      return <BrokerLandingPage />;
    case "all segments":
      return <AllSegments />;
    case "entity":
      return <Entity />;
    case "breeds":
      return <Breeds />;
    case "activity log":
      return <ActivityLog />;
    case "knockouts":
      return <KnockoutQuestions />;
    case "medical questions":
      return <MedicalQuestions />;
    case "occupancy type":
      return <OccupancyType />;
    // case "endorsement list":
    //   return <Endorsements />;
    case "new endorsement":
      return <NewEndorsementIframe />;
    // ==========JOURNEY ROUTES =================
    case "landing page":
      return <JourneyLandingPage />;
    case "lead details":
      return <JourneyLeadDetails />;
    case "credit details":
    case "cyber details":
    case "cattle details":
    case "gadget details":
    case "professional indemnity":
    case "select members":
    case "entity details":
    case "travel details":
    case "input transit details":
    case "marine details":
    case "pet details":
    case "fire details":
      return <InputsPageRender />;
    case "quotes":
      return <JourneyQuotesPage />;
    case "compare":
      return <JourneyComparePage />;
    case "proposal":
    case "insured fire":
    case "transit details":
    case "proposer details":
    case "insured details":
    case "insured items":
    case "nominee details":
    case "insured pets":
    case "venue location":
    case "indemnity details":
    case "insured cattle":
    case "ckyc details":
    case "workers details":
    case "property details":
    case "insured members":
    case "credit life details":
    case "member details":
    case "insured gadgets":
    case "cyber questions":
    case "insured travels":
    case "loan details":
      return <JourneyProposalPage />;
    case "proposal summary":
      return <JourneyProposalSummaryPage />;
    case "payment gateway":
      return <JourneyPaymentGatewayPage />;
    case "thank you":
      return <JourneyThankyouPage />;

    default:
      return <Home />;
  }
};

export default AllPages;
